import { IconType } from "@edaz/edazkit/Icon";
import { Input } from "@frui.ts/bootstrap";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault } from "@frui.ts/views/dist";
import FormGroup from "controls/formGroup";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col } from "react-bootstrap";
import Button from "@edaz/edazkit/Button/index";
import Form from "react-bootstrap/Form";

import UsersViewModel from "viewModels/users/users/usersViewModel";

export const searchBarContext = "searchBar";

export const SearchBarView: ViewComponent<UsersViewModel> = observer(({ vm }) => {
  return (
    <div className="bg-white px-5 py-4 rounded h-100 search-bar">
      <Form
        onSubmit={preventDefault(vm.applyFilterAndLoad)}
        onReset={preventDefault(() => vm.resetFilterAndLoad(vm.filter.providerKind))}>
        <Form.Row>
          <FormGroup as={Col} md={5} className="col-xxl-5" target={vm.filter} property="searchText">
            <Form.Label>{vm.translateAttribute("searchText")}</Form.Label>
            <Input placeholder={vm.translate("searchText")} />
          </FormGroup>
          <FormGroup as={Col} md={7} className="d-flex flex-column flex-xxl-row mb-0">
            <Form.Row className="d-flex justify-content-end">
              <FormGroup as={Col} md={12}>
                <Form.Label className="d-xxl-inline-block d-none">&nbsp;</Form.Label>
                <div className="text-right flex text-nowrap">
                  {vm.filter.searchText && (
                    <Button iconLeft={IconType.Cross} variant="outline-danger" className="btn-form-height" type="reset">
                      {vm.translate("resetFilter")}
                    </Button>
                  )}
                  <Button iconLeft={IconType.Search} className="btn-form-height" type="submit" disabled={vm.busyWatcher?.isBusy}>
                    {vm.translate("search")}
                  </Button>
                </div>
              </FormGroup>
            </Form.Row>
          </FormGroup>
        </Form.Row>
      </Form>
    </div>
  );
});

registerView(SearchBarView, UsersViewModel, searchBarContext);
